import Http from "@/commons/Http";

const path = 'api/protocol-financial';

export default {

    async save(dto, protocolId, id = ''){
        return Http.post(`${path}/${protocolId}/${id}`, dto);
    },

    async getAll(protocolId){
        return Http.get(`${path}/${protocolId}`);
    },

    async getById(id, protocolId){
        return Http.get(`${path}/${protocolId}/${id}`);
    },

    async getProtocolValues(protocolId){
        return Http.get(`${path}/${protocolId}/values`);
    },

    async delete(protocolId, id){
        return Http.delete(`${path}/${protocolId}/${id}`);
    },
}
